"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireWildcard(require("react"));
var _ykbStyledComponents = _interopRequireWildcard(require("../ykb-styled-components"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Resizer = require("./Resizer");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var StyledRow = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-mpl4p1-0"
})(["margin-left:-", ";margin-right:-", ";&:before{content:' ';display:table;}&:after{content:' ';display:table;clear:both;}"], function (props) {
  return props.theme.gutter;
}, function (props) {
  return props.theme.gutter;
});
var Row = /*#__PURE__*/function (_Component) {
  function Row(props) {
    var _this;
    (0, _classCallCheck2.default)(this, Row);
    _this = _callSuper(this, Row, [props]);
    if (props.observeElement === 'container') {
      _this.container = (0, _Resizer.getContainer)();
    }
    return _this;
  }
  (0, _inherits2.default)(Row, _Component);
  return (0, _createClass2.default)(Row, [{
    key: "renderChildren",
    value: function renderChildren(children) {
      return _react.default.Children.map(children, function (child) {
        if (! /*#__PURE__*/_react.default.isValidElement(child)) {
          return child;
        }
        return /*#__PURE__*/_react.default.cloneElement(child, {
          observeElement: 'container'
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        children = _this$props.children,
        observeElement = _this$props.observeElement;
      var newChildren = children;
      if (observeElement === 'container' && this.container) {
        newChildren = this.renderChildren(children);
      }
      return /*#__PURE__*/_react.default.createElement(_ykbStyledComponents.ThemeConsumer, null, function (theme) {
        return /*#__PURE__*/_react.default.createElement(StyledRow, (0, _extends2.default)({}, _this2.props, {
          theme: theme
        }), newChildren);
      });
    }
  }]);
}(_react.Component);
Row.defaultProps = {
  observeElement: 'window'
};
Row.propTypes = {
  observeElement: _propTypes.default.oneOf(['window', 'container'])
};
var _default = exports.default = Row;